// Filename: models/questionnaire/question.js
define('models/stats/week-stat',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
    'services/i18n',
], function(_, Backbone, U, API, i18n) {

    var UNITS = {
            calories: 'cal',
            duration: 'min',
            points: 'points'
        },
        LABELS = {
            calories: 'Burnt Calories',
            duration: 'Training time',
            distance: 'Distance',
            points: 'Total points'
        };


    var MWeekStat = Backbone.Epoxy.Model.extend({
        idAttribute: 'name',

        parse: function(data, opt) {
            if (data.name === "duration") data = this.convertDurationStats(data);
            return MWeekStat.__super__.parse.call(this, data, opt);
        },

        convertDurationStats: function(data) {
            var stats = _.omit(data, 'name');
            stats = _.mapObject(stats, function(val, key) {
                return val / 60;
            });
            return _.extend(data, stats);
        },

        isDistance: function() {
            return this.getName() === 'distance';
        },

        getName: function() {
            return this.get('name');
        },

        getUnit: function() {
            return UNITS[this.getName()];
        },

        getLabel: function() {
            return LABELS[this.getName()];
        },

    });

    // Return the model for the module
    return MWeekStat;
});

